import { AlarmClock } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const AlarmClockIcon = createLucideIcon(AlarmClock);
